/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type {DigitalAssetADto} from '@cohort/admin-schemas/digitalAsset';
import DigitalAssetReferenceComponent from '@cohort/merchants/components/references/DigitalAssetReferenceComponent';
import Table from '@cohort/merchants/components/Table';
import DigitalAssetObtentionBadge from '@cohort/merchants/pages/users/user/digital-assets/DigitalAssetObtentionBadge';
import DigitalAssetStatusBadge from '@cohort/merchants/pages/users/user/digital-assets/DigitalAssetStatusBadge';
import {formatDate} from '@cohort/shared/utils/format';
import {useTranslation} from 'react-i18next';

type UserDigitalAssetsTableProps = {
  isLoading: boolean;
  digitalAssets: DigitalAssetADto[];
};

const UserDigitalAssetsTable: React.FC<UserDigitalAssetsTableProps> = ({
  isLoading,
  digitalAssets,
}) => {
  const {t} = useTranslation('pages', {
    keyPrefix: 'users.user.digitalAssets.userDigitalAssetsTable',
  });

  return (
    <Table
      headers={[
        {label: t('tableHeaderCollection')},
        {label: t('tableHeaderObtentionDate')},
        {label: t('tableHeaderObtentionMethod')},
        {label: t('tableHeaderStatus')},
      ]}
      isLoading={isLoading}
      emptyState={{
        isEmpty: digitalAssets.length === 0,
        title: t('titleEmpty'),
        description: t('descriptionEmpty'),
      }}
    >
      {digitalAssets.map((digitalAsset: DigitalAssetADto) => (
        <tr
          key={`${digitalAsset.id}${digitalAsset.ownership?.obtentionDate}`}
          className="last:pr-0! *:py-3"
        >
          <td>
            <DigitalAssetReferenceComponent
              internalName={digitalAsset.digitalAssetCollection.internalName}
            />
          </td>
          <td className="text-slate-500">{formatDate(digitalAsset.ownership!.obtentionDate)}</td>
          <td>
            <DigitalAssetObtentionBadge status={digitalAsset.ownership!.obtentionType} />
          </td>
          <td>
            <DigitalAssetStatusBadge status={digitalAsset.ownership!.status} />
          </td>
        </tr>
      ))}
    </Table>
  );
};
export default UserDigitalAssetsTable;
